import { DEFAULT_STATE } from '../constants'

export const initialDatePublishedState = {
  datePublished: DEFAULT_STATE.datePublished,
  minDatePublished: DEFAULT_STATE.minDatePublished,
  maxDatePublished: DEFAULT_STATE.maxDatePublished,
}
